module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_sns_04-ec0d1bc3b5c575c59cf62e0bbf5805b8.jpg";